








































































































































import { EnpsInputTypes, InputType, NpsInputTypes } from '@/models/enums/InputType';
import { VueConstructor } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Arrow from './Arrow.vue';
import Buttons from './Buttons.vue';
import Emoticons from './Emoticons.vue';
import NpsButtonsColored from './NpsButtonsColored.vue';
import NpsGradientButtonsColored from './NpsGradientButtonsColored.vue';
import Slider from './Slider.vue';
import Stars from './Stars.vue';

@Component({ components: { NpsGradientButtonsColored, NpsButtonsColored, Buttons, Slider, Emoticons, Stars, Arrow } })
export default class ScoreInput extends Vue {
  @Prop() public value!: number;
  @Prop() public inputType!: InputType;
  @Prop({ default: true }) public allowPointer!: boolean;
  @Prop({ default: false }) public whiteMode!: boolean;
  @Prop({ default: false }) public isWidget!: boolean;

  @Prop()
  public descriptions!: string[];

  public get score(): number {
    return this.value;
  }

  public set score(value: number) {
    this.$emit('input', value);
  }

  public getNpsInputComponent(): VueConstructor {
    const scoreInputs: Record<NpsInputTypes, VueConstructor> = {
      [InputType.slider]: Slider,
      [InputType.arrow]: Arrow,
      [InputType.buttons]: Buttons,
      [InputType.npsGradientButtonsColored]: NpsGradientButtonsColored,
      [InputType.npsButtonsColored]: NpsButtonsColored,
    };

    return scoreInputs[this.inputType] ?? null;
  }

  public getEnpsInputComponent(): VueConstructor {
    const scoreInputs: Record<EnpsInputTypes, VueConstructor> = {
      [InputType.enpsSlider]: Slider,
      [InputType.enpsArrow]: Arrow,
      [InputType.enpsButtons]: Buttons,
      [InputType.enpsGradientButtonsColored]: NpsGradientButtonsColored,
      [InputType.enpsButtonsColored]: NpsButtonsColored,
    };

    return scoreInputs[this.inputType] ?? null;
  }
}
